import React from "react";
import { Container,Button } from "react-bootstrap";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination,Autoplay } from "swiper";
const Banner = () => {
  return (
    <div className="banner">
      <Container fluid className="p-0">
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Pagination,Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="slide-content">
            <img src={require('../../../images/slider/slider1.jpg')} alt="" className="w-100 h-100" />
                <div className="slide-text">
                    <Container>
                        <div className="slider-text-sub">
                          <span>Summer Sale</span>
                          <h1>Gen Apparel</h1>
                          <p className="p-0 m-0">Shop Now and get uoto 50% discount on your first shoping</p>
                          <Button>Grab it now</Button>
                        </div>
                    </Container>
                </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="slide-content">
                <img src={require('../../../images/slider/slider2.jpg')} alt="" className="w-100 h-100" />
                <div className="slide-text">
                    <Container>
                        <div className="slider-text-sub">
                          <span>Summer Sale</span>
                          <h1>Gen Apparel</h1>
                          <p className="p-0 m-0">Shop Now and get uoto 50% discount on your first shoping</p>
                          <Button>Grab it now</Button>
                        </div>
                    </Container>
                </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="slide-content">
            <img src={require('../../../images/slider/slider3.jpg')} alt="" className="w-100 h-100" />
                <div className="slide-text">
                    <Container>
                        <div className="slider-text-sub">
                          <span className="lg-screen">Summer Sale</span>
                          <h1>Gen Apparel</h1>
                          <p className="p-0 m-0">Shop Now and get uoto 50% discount on your first shoping</p>
                          <Button>Grab it now</Button>
                        </div>
                    </Container>
                </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="slide-content">
            <img src={require('../../../images/slider/slider4.jpg')} alt="" className="w-100 h-100" />
                <div className="slide-text">
                    <Container>
                        <div className="slider-text-sub">
                          <span className="lg-screen">Summer Sale</span>
                          <h1>Gen Apparel</h1>
                          <p className="p-0 m-0">Shop Now and get uoto 50% discount on your first shoping</p>
                          <Button>Grab it now</Button>
                        </div>
                    </Container>
                </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </Container>
    </div>
  );
};

export default Banner;
